import axios from 'axios';

const BASE_URL =
  process.env.REACT_APP_API_URL ||
  // 'https://event-sharing-server-6dd4a92d6d2a.herokuapp.com/api';
  'http://localhost:3000/api';

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  // 500s. Generous on purpose: a large batched image upload over a poor
  // mobile connection can take minutes. The previous comment said "5 second
  // timeout" but the value was always 500000ms; comment fixed, value kept.
  timeout: 500000,
});

// Request interceptor for adding auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for handling errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED') {
      console.error('Server connection failed. Please check if the backend server is running at:', BASE_URL);
      return Promise.reject({
        response: {
          data: {
            message: 'Server connection failed. Please make sure the backend server is running.',
            error: error.message,
            code: error.code
          }
        }
      });
    }
    
    if (error.response?.status === 429) {
      console.error('Rate limit exceeded. Please try again later.');
    }
    
    return Promise.reject(error);
  }
);

// Helper function to check server availability
export const checkServerAvailability = async () => {

    return true;

};

export default api; 